import { render, staticRenderFns } from "./VPayment.vue?vue&type=template&id=5eb46326&"
import script from "./VPayment.vue?vue&type=script&lang=js&"
export * from "./VPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports